/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { organizationsUpdateInviteRole } from "../funcs/organizationsUpdateInviteRole.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { OrganizationInvitation } from "../models/components/organizationinvitation.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  UpdateInviteRoleRequest,
  UpdateInviteRoleSecurity,
} from "../models/operations/updateinviterole.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type UpdateInviteRoleMutationVariables = {
  request: UpdateInviteRoleRequest;
  security?: UpdateInviteRoleSecurity | undefined;
  options?: RequestOptions;
};

export type UpdateInviteRoleMutationData = OrganizationInvitation;

export type UpdateInviteRoleMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * updateInviteRole organizations
 *
 * @remarks
 * Change the role assigned to a pending WorkOS invitation.
 */
export function useUpdateInviteRoleMutation(
  options?: MutationHookOptions<
    UpdateInviteRoleMutationData,
    UpdateInviteRoleMutationError,
    UpdateInviteRoleMutationVariables
  >,
): UseMutationResult<
  UpdateInviteRoleMutationData,
  UpdateInviteRoleMutationError,
  UpdateInviteRoleMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildUpdateInviteRoleMutation(client, options),
    ...options,
  });
}

export function mutationKeyUpdateInviteRole(): MutationKey {
  return ["@gram/client", "organizations", "updateInviteRole"];
}

export function buildUpdateInviteRoleMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: UpdateInviteRoleMutationVariables,
  ) => Promise<UpdateInviteRoleMutationData>;
} {
  return {
    mutationKey: mutationKeyUpdateInviteRole(),
    mutationFn: function updateInviteRoleMutationFn({
      request,
      security,
      options,
    }): Promise<UpdateInviteRoleMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(organizationsUpdateInviteRole(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
